var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSegmentationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.921,
    viewBox: "0 0 20 18.921",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "segmentation_icon",
    d: "M24.421,24.921H7.579A1.619,1.619,0,0,1,6,23.342V7.579A1.619,1.619,0,0,1,7.579,6H24.421A1.619,1.619,0,0,1,26,7.579V23.342a1.619,1.619,0,0,1-1.579,1.579ZM7.579,11.289H24.421V7.579H7.579Zm3.947,1.579H7.579V23.342h3.947Zm8.947,0V23.342h3.947V12.868Zm-1.579,0H13.105V23.342h5.789Z",
    transform: "translate(-6 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentationIcon);
export default __webpack_public_path__ + "static/media/segmentation_icon.507881b8237546ffb709e6acda899059.svg";
export { ForwardRef as ReactComponent };